export default __webpack_public_path__ + "static/cafetera2-07fa694dcf14236af6a3cf831fbd6289.png";